import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../authentication/auth.service';
import { CommonService } from '../services/common-service';
import { NotificationService } from '../services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  // browserName: string;
  // duplicateBrowser: boolean = false;
  // isLoggedOut: boolean = false;
  // concurrentSessionAllowed: boolean = false;
  // ipAddress;

  constructor(
    private auth: AuthService,
    private commonService: CommonService,
    private router: Router,
    private notificationService:NotificationService
  ) {}
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
    return this.auth.isAuthenticated$.pipe(
        map((loggedIn)=>{
          if(loggedIn){
            const assignedMenus = this.commonService.getAssignedMenus();
            console.log(next?.routeConfig)
            let url = state?.url;
            if(state?.url?.includes('?')){
              const split = state?.url?.split('?');
              url = split && split?.length? split[0]: state?.url;
            }
            console.log(url);
            return true;
            // if(url==='/partner-portal'|| (assignedMenus && assignedMenus[url])){
            //   return true;
            // }else{
            //   this.notificationService?.showError(`Access not allowed!`,'');
            //   this.router?.navigate(['/partner-portal']);
            //   return false;
            // }
          }else{
            localStorage.removeItem('mnus');
            this.auth.login(state?.url);
            return false;
          }
        })
      );
  }
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Promise<boolean | UrlTree> | Observable<boolean | UrlTree> {
    return this.auth.isAuthenticated$.pipe(
      map((loggedIn)=>{
        console.log(childRoute.url,state.url,childRoute.routeConfig?.path,childRoute?.parent);
        return loggedIn;
      })
    )
  }
}
